import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import Icon from "../../common/icons/Icon";
import { pushToast } from "../../redux/actions";
import UpgradeSubscriptionModal from "./UpgradeSubscriptonModal";
import { contactBryan } from "./golf-schools/redux/actions";

const validate = (values) => {
  const errors = { valid: true };
  const { name, email, phone } = values;

  if (!name || name.length < 2) {
    errors.valid = false;
    errors.name = "Field required";
  }
  if (!phone || phone.length < 2) {
    errors.valid = false;
    errors.phone = "Field required";
  }
  const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  if (!email || email.length < 5) {
    errors.valid = false;
    errors.email = "Field required";
  } else if (email.match(emailRegex) === null) {
    errors.valid = false;
    errors.email = "Invalid email";
  }
  return errors;
};

const trainingOptions = [
  // {
  //   name: "Tathata Golf Schools",
  //   description:
  //     "Enjoy a one-of-a-kind training environment at the home of Tathata Golf. These multi-day experiences will take your training to a deeper level.",
  //   imageUrl:
  //     "https://d27vybgvtr1dba.cloudfront.net/golf-schools/graduate-school.jpg",
  //   linkText: "View Schools",
  //   linkTo: "/subscription/coaching/golf-schools",
  // },
  {
    name: "Tathata Online Follow-Up",
    description:
      "Get support with any of the Tathata Training Courses from your own home through a live video call with Bryan Hepler.",
    imageUrl: "https://d27vybgvtr1dba.cloudfront.net/training-online.jpg",
    linkText: "Learn More",
    linkTo: "/subscription/coaching/online-follow-up",
  },
  // {
  //   name: "Tathata In-Person Follow-Up",
  //   description:
  //     "Experience the Tathata Training Center & receive live 1-on-1 support from Bryan Hepler or a Tathata staff member.",
  //   displayLocation: true,
  //   imageUrl: "https://d27vybgvtr1dba.cloudfront.net/coaching-inperson.jpg",
  //   linkText: "Learn More",
  //   linkTo: "/subscription/coaching/in-person-follow-up",
  // },
  // {
  //   name: "Movement Specialist Follow-Up",
  //   description:
  //     "Receive live 1-on-1 support on your 60-Day Training Program Body Movements from a Certified Movement Specialist near you.",
  //   imageUrl: "https://d27vybgvtr1dba.cloudfront.net/training-ms.jpg",
  //   linkText: "Find a Movement Specialist",
  //   linkTo: "/subscription/coaching/movement-specialists",
  // },
  {
    name: "Swing Submittals",
    description:
      "Send in a video of your full swing, short game or putting motions & receive an in-depth video analysis & feedback from Bryan Hepler.",
    imageUrl: "https://d27vybgvtr1dba.cloudfront.net/training-swingsub.jpg",
    linkText: "Learn More",
    linkTo: "/subscription/coaching/swing-submittals",
  },
  {
    name: 'Bryan Hepler "On Tour" Near You',
    description:
      "Come Train with Founder Bryan Hepler in your hometown at a tour stop you are attending",
    imageUrl: "https://d27vybgvtr1dba.cloudfront.net/training-bryan-tour.jpg",
    linkText: "Learn More",
    linkTo: "/subscription/coaching/golf-schools/5",
  },
];

class TrainingPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      submitting: false,
      submitted: false,
      name: "",
      email: "",
      phone: "",
      errors: { valid: true },
    };
  }

  renderHero = () => {
    return (
      <div className="hero__wrapper gs__hero__wrapper">
        <div className="container">
          <div className="gs__hero">
            <h1>Train With Bryan</h1>
            <h3>
              As a Tathata Golf member, you have the ability to book a variety
              of additional coaching options both online & in person with
              founder Bryan Hepler. He is here to support you.
            </h3>
            <h4>
              Want multiple Follow-Ups? Save money by upgrading to a Tathata
              Golf Coaching Package or make any one-time purchase below
            </h4>
            <br />
            <UpgradeSubscriptionModal />
          </div>
        </div>
      </div>
    );
  };

  handleFieldChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
      errors: { valid: true },
    });
  };

  submitContact = (e) => {
    e.preventDefault();

    this.setState({ submitting: true });

    const errors = validate(this.state);
    if (!errors.valid) {
      this.setState({ errors });
      return;
    }

    this.props
      .dispatch(
        contactBryan({
          name: this.state.name,
          email: this.state.email,
          phone: this.state.phone,
        })
      )
      .then((action) => {
        if (!action.response.ok) {
          this.props.dispatch(
            pushToast({
              message: "There was a problem while submitting your request.",
              status: "error",
            })
          );
        } else {
          this.setState({
            errors: { valid: true },
            name: "",
            email: "",
            phone: "",
            submitted: true,
          });
          this.props.dispatch(
            pushToast({
              message: "Email sent!",
            })
          );
        }
        this.setState({ submitting: false });
      });
  };

  render() {
    return (
      <div className="gs__wrapper">
        {this.renderHero()}
        <div className="gs__content">
          {trainingOptions.map((option, key) => (
            <div className="gs__card" key={key}>
              <div className="gs__card-content">
                <div
                  className="gs__card__image"
                  style={{ backgroundImage: `url(${option.imageUrl})` }}
                >
                  {option.displayLocation && (
                    <span className="gs__card__image--mapmarker">
                      <Icon icon="MapMarker" /> In Scottsdale, AZ
                    </span>
                  )}
                </div>
                <h2>{option.name}</h2>
                <p>{option.description}</p>
              </div>
              <Link className="button gs__card--btn" to={option.linkTo}>
                {option.linkText}
              </Link>
            </div>
          ))}
          <div className="gs__card gs__card__clean">
            <h2 className="gs__card__title">
              Want a custom school? Fly Bryan to you!
            </h2>
            <div className="gs__card__form">
              <h3>E-MAIL BH@TATHATA.COM</h3>
              <h3>OR</h3>
              <h1>REQUEST A CALL FROM BRYAN TODAY!</h1>

              <form onSubmit={this.submitContact}>
                <input
                  type="text"
                  placeholder="Name"
                  name="name"
                  value={this.state.name}
                  onChange={this.handleFieldChange}
                />
                {this.state.errors.name && (
                  <div className="gs__input__error">
                    {this.state.errors.name}
                  </div>
                )}
                <input
                  type="text"
                  placeholder="Email Address"
                  name="email"
                  value={this.state.email}
                  onChange={this.handleFieldChange}
                />
                {this.state.errors.email && (
                  <div className="gs__input__error">
                    {this.state.errors.email}
                  </div>
                )}
                <input
                  type="text"
                  placeholder="Phone"
                  name="phone"
                  value={this.state.phone}
                  onChange={this.handleFieldChange}
                />
                {this.state.errors.phone && (
                  <div className="gs__input__error">
                    {this.state.errors.phone}
                  </div>
                )}
                <div>
                  <button
                    type="submit"
                    className="button button--large"
                    disabled={this.state.submitting}
                  >
                    {this.state.submitting ? "SUBMITTING" : "SUBMIT"}
                  </button>
                  {this.state.submitted && (
                    <div className="gs__form__success">Email submitted!</div>
                  )}
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect()(TrainingPage);



// WEBPACK FOOTER //
// ./src/subscription/coaching/TrainingPage.js